import envelope from "./envelope";
import evidences from "./evidences";
import clues from "./clues";

export default [
    envelope,
    evidences,
    clues
];